module.exports = __webpack_public_path__ + "img/vsms-full.5aa03f54.svg";